/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import { useCandidateService } from 'domain/shared/candidate';
const CANDIDATE_CONTEXT = 'Candidate';

const CandidateContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getCombinedPermissions } = useCandidateService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getCombinedPermissions}
      permissionToCheck={permissionToCheck}
      contextName={CANDIDATE_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default CandidateContext;
